import React, { useState } from 'react';
import { View, Text, StyleSheet, ScrollView } from 'react-native';
import TouchNavGroup from '../../../../common/components/navpanel/TouchNavGroup';
import BasicLayout from '../../../../common/components/CustomLayout/BasicLayout';

import VRPrices from './prices/Prices';
import PenaltyRules from './penalty/rules/Rules';
import DeliveryCharges from '../deliverycharges/DeliveryCharges';

const VehicleRentalPrices = ({ navigation, openInventory }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemClick = (itemName) => {
    setSelectedItem(itemName);
  };

  if (selectedItem) {
    switch (selectedItem) {
      case 'Prices':
        return <VRPrices navigation={navigation} goBack={() => setSelectedItem(null)} />;
      case 'Up Charges':
        return <DeliveryCharges navigation={navigation} goBack={() => setSelectedItem(null)} />;
      case 'Penalty Rules':
        return <PenaltyRules navigation={navigation} goBack={() => setSelectedItem(null)} />;
      default:
        return null;
    }
  }

  return (
    <BasicLayout
      navigation={navigation}
      goBack={() => openInventory(null)}
      screenName={'Vehicle Rental Pricing'}
    >
      <ScrollView>
        <View style={styles.container}>
          <TouchNavGroup
            sectionTitle="Vehicle Configuration"
            items={[
              { title: 'Prices', icon: 'tag' },
            ]}
            handleItemClick={handleItemClick}
          />
          <TouchNavGroup
            sectionTitle="Penalties & Fees"
            items={[
              { title: 'Up Charges', icon: 'shipping-fast' },
              { title: 'Penalty Rules', icon: 'exclamation-triangle' },
            ]}
            handleItemClick={handleItemClick}
          />
        </View>
      </ScrollView>
    </BasicLayout>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    width: '90%',
    maxWidth: 1000,
    margin: 'auto',
    marginTop: 40,
  },
});

export default VehicleRentalPrices;
